import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'trending-up-2', 'TrendingUp2', [["path",{"d":"M18 5l3 3l-3 3"}],["path",{"d":"M3 18h5l7 -10h6"}]]);